/** Payload salvo após GET /company/domain (?domain=master) para buscar o avatar autenticado. */
export const LS_COMPANY_LOGO_PAYLOAD = 'fisital_company_logo_payload';

export const LS_USER_DISPLAY_NAME = 'fisital_user_display_name';
export const LS_USER_EMAIL = 'fisital_user_email';

/** IDs das verticais selecionadas no filtro da aba Parametrizações → Verticais. */
export const LS_VERTICALS_FILTER_IDS = 'fisital_verticals_filter_ids';
